<template>
  <div class="home-container" style="height: 100%;">
    <div class="home-content" style="height: 100%;">
      <iframe style="width: 100%;height: 100%;" :src="xscUrl" scrolling="auto" frameborder="0"></iframe>
      <!-- 搜索 -->
      <!-- <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                label-width="100px"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.ridgepoleId"
                  clearable filterable
                  placeholder="请选择楼栋"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.unitId"
                  clearable filterable
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="楼层名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.floorId"
                  clearable filterable
                  placeholder="请选择楼层"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="房间名称"
                prop="roomName"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.roomName"
                  placeholder="请输入房间名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="房屋信息"
                prop="keyword"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入房屋信息"
                ></el-input>
              </el-form-item>
            </el-col>                  
            <el-col :span="8">
              <el-form-item label="选择时间" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="是否销户"
                prop="phone"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.isXiaohu" placeholder="请选择">
                  <el-option
                    v-for="(item, ind) in XiaohuList"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <div style="margin: 20px; display: flex; align-items: center">
          <el-button
            size="small"
            type="primary"
            style="width: 90px; margin-right: 15px"
            icon="el-icon-download"
          >
            <a :href="baseUrL" download style="color: #fff"
              >下载模板</a
            ></el-button
          >
          <el-upload
            class="avatar-uploader"
            ref="upload"
            action=""
            :http-request="handleUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :show-file-list="false"
          >
            <el-button
              size="small"
              type="primary"
              style="width: 90px; margin-right: 15px"
              icon="el-icon-upload2"
            >
              导入账单
            </el-button>
          </el-upload>
          <el-button size="small" @click="batchReview" type="primary"
            >批量审核</el-button
          >
          <el-button size="small" @click="sendNotice" type="primary"
            >发送缴费通知</el-button
          >          
          <el-button
            size="small"
            @click="onLoad(1)"
            type="primary"
            icon="el-icon-search"
            >搜索</el-button
          >
          <el-button
            size="small"
            @click="restSearch"
            type="danger"
            icon="el-icon-refresh"
            >重置</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        ref="table"
        @select="handleSelect"
        type="selection"
        @select-all="handleSelectAll"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="address" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="cycleTime" label="缴费周期" align="center">
        </el-table-column>
        <el-table-column
          prop="billCategoryName"
          label="缴费类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="billPrice" label="缴费金额" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >删除</el-button
            >
            <el-button @click="updataRecord(scope.row)" type="text" size="small"
              >修改</el-button
            >
            <el-button
              v-if="scope.row.status == '未支付'"
              @click="writeOff(scope.row)"
              type="text"
              size="small"
              >核销</el-button
            >
          </template>
        </el-table-column>
      </el-table> -->
      <!-- 分页器 -->
      <!-- <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog title="核销" :visible.sync="dialogVisible" width="40%">
        <el-form :model="from" ref="Form" :rules="fromRules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="支付类型"
                prop="payType"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="from.payType" placeholder="请选择支付类型">
                  <el-option
                    v-for="item in payTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
                        <el-col :span="12">
              <el-form-item
                label="核销时间"
                prop="writeOffTime"
                label-width="100px"
                style="width: 80%"
              >
                <el-date-picker
                  v-model="from.writeOffTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择核销日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="12" v-if="!batchType">
              <el-form-item
                label="核销金额"
                prop="price"
                label-width="100px"
                style="width: 80%"
              >
                <el-input-number
                  v-model="from.price"
                  :min="0"
                  label="请输入金额"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="batchType?24:12">
              <el-form-item
                label="备注"
                prop="des"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入备注"
                  v-model="from.des"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="writeOffSubmit(1)">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="moudelName" :visible.sync="isShowFlag" width="50%">
        <el-form :model="addData" ref="Forms" :rules="rules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="账单金额"
                prop="billPrice"
                style="width: 80%"
              >
                <el-input-number
                  v-model="addData.billPrice"
                  :min="0"
                  label="请输入金额"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择时间" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="addData.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择类型" prop="billCategoryId">
                <el-select
                  clearable filterable
                  v-model="addData.billCategoryId"
                  placeholder="请选择类型"
                >
                  <el-option
                    v-for="(item, ind) in typeData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注 " prop="remark">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="addData.remark"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowFlag = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </span>
      </el-dialog> -->
  <!-- 新增模态框 -->
  <!-- <el-dialog title="发送通知" :visible.sync="sendFlags" width="50%" :close-on-click-modal="false">
    <el-form
      ref="form"
      :model="sendData"
      label-width="90px"
      label-position="center"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="发送类型">
            <el-radio-group v-model="sendData.type">
              <el-radio :label="1">站内信</el-radio>
              <el-radio :label="2">小程序通知</el-radio>
              <el-radio :label="3">短信</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="sendFlags = false">取 消</el-button>
      <el-button type="primary" @click="sendSubmit" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>       -->
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
export default {
  data() {
    return {
      sendData:{
        type:1
      },
      sendFlags:false,
      btnLoading:false,
      searchForm: {
        billOrderNo: "",
        endTime: "",
        startTime: "",
        time: "",
        payType: "",
        ridgepoleId: "",
        unitId: "",
        floorId: "",
        roomName: "",
        billCategoryId: "",
        isXiaohu: "",
      },
      batchType:false,
      from: {},
      addData: {},
      baseUrL: process.env.VUE_APP_UPLOAD_REAL_PATH + "/bill/importTemplate",
      XiaohuList: [
        {
          id: 1,
          name: "是",
        },
        {
          id: 0,
          name: "否",
        },
      ],
      fromRules: {
        payType: [
          { required: true, message: "请选择支付类型", trigger: "blur" },
        ],
        // price: [{ required: true, message: "请输入核销金额", trigger: "blur" }],
        writeOffTime: [
          { required: true, message: "请选择核销时间", trigger: "blur" },
        ],
      },
      rules: {
        billCategoryId: [
          { required: true, message: "请选择缴费类型", trigger: "blur" },
        ],
        payType: [
          { required: true, message: "请选择支付类型", trigger: "blur" },
        ],
        billPrice: [
          { required: true, message: "请输入账单金额", trigger: "blur" },
        ],
        time: [{ required: true, message: "请选择时间周期", trigger: "blur" }],
      },
      payTypeList: [
      {
          id: 1,
          name: "微信线上",
        }, {
          id: 7,
          name: "微信线下",
        },
        {
          id: 2,
          name: "支付宝",
        },
        {
          id: 3,
          name: "现金",
        },
        {
          id: 4,
          name: "银行卡",
        },
        {
          id: 5,
          name: "对公转账",
        },{
          id: 6,
          name: "一卡通",
        },
      ],
      tableData: [],
      dialogVisible: false,
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
      typeData: [],
      isShowFlag: false,
      moudelName: "",
      managers: [],
      sendIds:'',
      xscUrl:'https://szwy.zjwsrc.com/wyweb/#/unpaidPayment'
    };
  },
  watch: {
    //监听表格数据变化时回显，判断有数据时及弹窗绑定值为true时调用回显,不然会报同上问题
    tableData(newVal) {
      if (newVal.length > 0) {
        this.showSelection();
      }
    },
  },
  mounted() {
    this.xscUrl = this.xscUrl + '?userName=' + JSON.parse(localStorage.getItem('ToUserInfo')).account 
    this.onLoad();
  },
  methods: {
    // 发送未交费通知
    sendSubmit(){
      let data = {
        billIds:this.sendIds,
        sendType:this.sendData.type
      }
      this.$Apis.sendBill(data).then(res=>{
        if(res.code == 200){
          this.$message.success('发送成功')
          this.sendFlags = false;
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    sendNotice(){
      if (this.managers.length > 0) {
        this.sendIds = this.managers.map((res) => res.id).join(",");
        this.sendData.type = 1
        this.sendFlags = true;
      } else {
        this.$message.warning("请选择后，发送！");
      }
    },    
    //多选
    handleSelect(selection, row) {
      //声名标记，判断已选择项数组是否存在当前选中项，若存在删除该项，不存在则添加
      let flag;
      //深拷贝已选择项，我这里是兄弟组件传值，改变原数组的话会导致还没点击确定，兄弟组件就接到了新值
      let newArr = JSON.parse(JSON.stringify(this.managers));
      newArr.forEach((item, index) => {
        if (item.id == row.id) {
          newArr.splice(index, 1);
          flag = true;
        }
      });
      if (!flag) {
        newArr.push({ id: row.id });
      }
      this.managers = newArr;
    },
    //全选
    handleSelectAll(selection) {
      //参数selection为当前页的选中项数组,长度大于0则为全部选中，相反为全部取消选中
      if (selection.length > 0) {
        //stateArr为暂存已选择项,深拷贝selection数组，这里是将selection元素全部添加到stateArr
        this.stateArr = JSON.parse(JSON.stringify(selection));
        //深拷贝已选中项数组，因业务需求我这里是兄弟组件传入的已选中项，
        //由于是点击确定按钮时传值不另外声名的话会导致改变managers时
        //兄弟组件监听到变化直接改变了managers数组
        let newManagers = JSON.parse(JSON.stringify(this.managers));
        selection.forEach((item) => {
          newManagers.push({ id: item.id });
        });
        //数组中对象根据id去重
        var objItem = {},
          newAry = [];
        for (var i = 0; i < newManagers.length; i++) {
          if (!objItem[newManagers[i].id]) {
            newAry.push(newManagers[i]);
            objItem[newManagers[i].id] = true;
          }
        }
        this.managers = newAry;
      } else {
        //取消全部选中的状态，此时stateArr为当前业的表格数据，用于判断取消选中的哪页数据
        this.stateArr = JSON.parse(JSON.stringify(this.tableData));
        //map方法将每项的id放 入set数组中
        var set = this.stateArr.map((item) => {
          return item.id;
        });
        //根据id过滤掉已选择项数组中存在这些id的数据
        var resArr = this.managers.filter((item) => !set.includes(item.id));
        this.managers = resArr;
      }
    },
    //表格多选回显
    showSelection() {
      let arr = [];
      let set = this.managers.map((item) => {
        return item.id;
      });
      //过滤出已选择项和table数据中id对应上的数据，完成回显
      arr = this.tableData.filter((item) => {
        return set.includes(item.id);
      });
      this.$nextTick(() => {
        arr.forEach((item) => {
          this.$refs.table.toggleRowSelection(item);
        });
      });
    },
    // 批量核销
    batchReview() {
      if (this.managers.length > 0) {
        this.writeOffId = this.managers.map((res) => res.id).join(",");
        this.from = {}
        this.batchType = true
        this.dialogVisible = true;
      } else {
        this.$message.warning("请选择后，核销！");
      }
    },
    onSubmit() {
      this.$refs.Forms.validate((valid) => {
        if (valid) {
          let { billCategoryId, remark, billPrice, time, id } = this.addData;
          let data = {
            cycleStartTime: reg.filterDataTime(time[0]),
            cycleEndTime: reg.filterDataTime(time[1]),
            billCategoryId,
            billPrice,
            remark,
            id: id || "",
          };
          this.$Apis.billUp(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.managers = [];
              this.onLoad();
              this.isShowFlag = false;
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 修改账单
    updataRecord(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.time = row.cycleTime.split("~");
      this.isShowFlag = true;
      this.moudelName = "修改";
    },
    // 核销账单
    writeOffSubmit(sum) {
      console.log(this.$refs);
      this.$refs.Form.validate((valid) => {
        if (valid) {
          console.log(this.from);
          let { ids, payType, des, price, writeOffTime } = this.from;
          let data = {
            ids: this.writeOffId,
            payType,
            des,
            price:price || '',
            writeOffTime,
          };
          data.type = sum;
          this.$Apis.billWriteOff(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.onLoad();
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 核销
    writeOff(row) {
      this.writeOffId = row.id;
      this.from = {}
      this.batchType = false
      this.dialogVisible = true;
    },
    // 房间信息导入
    handleUpload({ file }) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        var formData = new FormData();
        formData.append("file", file);
        formData.append(
          "villageId",
          JSON.parse(localStorage.getItem("park_data")).id
        );
        this.$Apis.billImportCreateBill(formData).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
          loading.close();
        });
      } catch (error) {
        loading.close();
      }
    },
    handlePreview() {},
    handleRemove() {},
    // 批量生成账单
    generateBill() {},
    // 选择楼栋
    ridgepoleSelect(e) {
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.searchForm.unitId = ''
          this.searchForm.floorId = ''
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e, row) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.floorList = res.data;
          this.searchForm.floorId = ''
          if (row == "updata") {
            this.isAddModal = true;
          }
        }
      });
    },
    onLoad(ind) {
      this.isShowloading = true;
      let {
        billOrderNo,
        time,
        payType,
        ridgepoleId,
        unitId,
        floorId,
        roomName,
        billCategoryId,
        isXiaohu,
        keyword
      } = this.searchForm;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        billOrderNo,
        endTime: reg.filterTime(time[1]),
        startTime: reg.filterTime(time[0]),
        payType,
        ridgepoleId,
        unitId,
        floorId,
        roomName,
        billCategoryId,
        isXiaohu,
        keyword,
        verifyStatus: 1,
      };
      this.tableData = [];
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });
      this.$Apis.billCategoryAllList(page).then((res) => {
        if (res.code == 200) {
          this.typeData = res.data;
        }
      });
      this.$Apis.billNotPayList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          this.dialogVisible = false;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    handleClick(row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.billDel({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style scoped>
/deep/.el-upload-list {
  display: none;
}
</style>